export default __webpack_public_path__ + "static/media/number-3.14754ae0.svg";